global.$ = global.jQuery = require('jquery');


$(document).ready(function (){

        var $$ = Dom7;
        var app = new Framework7({
            root: '#app',
            theme: 'md',
            routes: [
                // Index page
                {
                    path: '/menu/',
                    url: '/menu/',
                    name: 'menu',
                },
                // Menu - Ostriche
                {
                    path: '/ostriche',
                    url: '/ostriche/',
                    name: 'Ostriche',
                },
                // Menu - Caviale
                {
                    path: '/caviale',
                    url: '/caviale/',
                    name: 'Caviale',
                },
                {
                    path: '/plateau',
                    url: '/plateau/',
                    name: 'Plateau',
                },
                {
                    path: '/piatti-di-mare',
                    url: '/piatti-di-mare/',
                    name: 'Piatti di mare',
                },
                {
                    path: '/primi-piatti',
                    url: '/primi-piatti/',
                    name: 'Primi Piatti',
                },
                // Menu - Dessert
                {
                    path: '/dessert',
                    url: '/dessert/',
                    name: 'Dessert',
                },
                // Menu - Laboratorio di mare
                {
                    path: '/laboratorio',
                    url: '/laboratorio/',
                    name: 'Laboratorio di mare',
                },
                // Cantina page
                {
                    path: '/cantina/',
                    url: '/cantina/',
                    name: 'cantina',
                },
                //  Bevande - Champagne
                {
                    path: '/cantina/champagne',
                    url: '/cantina/champagne/',
                    name: 'champagne',
                },
                // Bevande - Bollicine
                {
                    path: '/cantina/bollicine',
                    url: '/cantina/bollicine/',
                    name: 'bollicine',
                },
                // Bevande - Vini bianchi
                {
                    path: '/cantina/vini-bianchi-italia',
                    url: '/cantina/vini-bianchi-italia/',
                    name: 'vinibianchiitalia',
                },
                // Bevande - Vini rossi
                {
                    path: '/cantina/vini-rossi-italia',
                    url: '/cantina/vini-rossi-italia/',
                    name: 'vinirossiitalia',
                },
                // Bevande - Vini bianchi
                {
                    path: '/cantina/vini-bianchi-francia-mondo',
                    url: '/cantina/vini-bianchi-francia-mondo/',
                    name: 'vinibianchimondo',
                },
                // Bevande - Vini rossi
                {
                    path: '/cantina/vini-rossi-francia-mondo',
                    url: '/cantina/vini-rossi-francia-mondo/',
                    name: 'vinirossimondo',
                },
                // Bevande - Vini rosé
                {
                    path: '/cantina/vini-rose',
                    url: '/cantina/vini-rose/',
                    name: 'vinirose',
                },
                // Bevande - Vini dessert
                {
                    path: '/cantina/vini-dessert',
                    url: '/cantina/vini-dessert/',
                    name: 'vinidessert',
                },
                // Bevande - Vini al calice
                {
                    path: '/cantina/vini-calice',
                    url: '/cantina/vini-calice/',
                    name: 'vinicalice',
                },
                // Bevande - Birre
                {
                    path: '/cantina/birre',
                    url: '/cantina/birre/',
                    name: 'birre',
                },
                // Bevande page
                {
                    path: '/bevande/',
                    url: '/bevande/',
                    name: 'bevande',
                },
                // Bevande - Vino della casa
                {
                    path: '/bevande/fredde',
                    url: '/bevande/fredde/',
                    name: 'fredde',
                },
                // Bevande - Bibite e caffè
                {
                    path: '/bevande/caffetteria',
                    url: '/bevande/caffetteria/',
                    name: 'caffetteria',
                },
                // Bevande - Spritz
                {
                    path: '/bevande/aperitivo',
                    url: '/bevande/aperitivo/',
                    name: 'aperitivo',
                },
                // Bevande - Grappe e amari
                {
                    path: '/bevande/cocktail',
                    url: '/bevande/cocktail/',
                    name: 'cocktail',
                },
                // Visualizzazione singolo cibo
                {
                    path: '/:slug/item/:id',
                    url: '/{{slug}}/item/{{id}}/',
                    name: 'vistacibo',
                },
                // Bevande page
                {
                    path: '/visita-da-mobile',
                    url: '/visita-da-mobile/',
                    name: 'visitadamobile',
                },
                // Default route (404 page). MUST BE THE LAST
                {
                    path: '(.*)',
                    url: '404',
                },
            ],
            view : {
                pushState: false
            },
        });

        $$('form.ajax-submit').on('form:success', function (e) {
            var xhr = e.detail.xhr; // actual XHR object

            var data = e.detail.data; // Ajax response from action file
            // do something with response data
        });

        if('serviceWorker' in navigator) {
            navigator.serviceWorker.register('/sw.js').then(function() {
                console.log("Service Worker Registered");
            });
            console.log('serviceWorker')
        }

        /** IOS BANNER **/
// Detects if device is on iOS
        const isIos = () => {
            const userAgent = window.navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod/.test( userAgent );
        };
// Detects if device is in standalone mode
        const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

// Checks if should display install popup notification:
        if (isIos() && !isInStandaloneMode()) {
            app.dialog.alert('Premi sul pulsante di condivisione e poi selezionare la voce "Aggiungi alla schermata home".', 'Installazione App');
            $$(document).on('click','#install-app-button',function (e) {
                app.dialog.alert('Premi sul pulsante di condivisione e poi seleziona la voce "Aggiungi alla schermata home".', 'Installazione App');
            });
        }

        if (isIos() && isInStandaloneMode()) {
            jQuery('.toolbar.tabbar.tabbar-labels.toolbar-bottom-md').addClass('iphone-installed');
        }
        $$(document).on('page:init', function (e) {
            if (isIos() && isInStandaloneMode()) {
                jQuery('.toolbar.tabbar.tabbar-labels.toolbar-bottom-md').addClass('iphone-installed');
            }
        });
        /** END IOS BANNER **/

        /** DESKTOP BLOCK **/
        if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
            console.log('Mobile Detected');
        }
        else {
            console.log('Desktop Detected');
            app.router.navigate('/visita-da-mobile');
        }
// /** END DESKTOP BLOCK **/


        var deferredPrompt;
        $$(window).on('beforeinstallprompt',function (e) {
            // Prevent the mini-infobar from appearing on mobile
            e.preventDefault();
            // Stash the event so it can be triggered later.
            deferredPrompt = e;
            console.log(deferredPrompt)
            // Update UI notify the user they can install the PWA
        });
        $$(document).on('click','#install-app-button',function (e) {
            // Show the install prompt
            deferredPrompt.prompt();
            // Wait for the user to respond to the prompt
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the install prompt');
                } else {
                    console.log('User dismissed the install prompt');
                }
            });
        });
        $$(document).on('click','.confirm-ok',function (e) {
            app.dialog.confirm('Stai per lasciare quest\'applicazione. Confermi?', 'Attenzione', function () {
                window.open('https://krudo.eu/', '_blank');
            });
        });

    // $(document).tooltip({
    //     selector: "[data-toggle=tooltip]"
    // });
});

